import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import yup from '../../../common/utils/yup';
import { TextField, AutoComplete, DateTimePicker, Select } from 'porosys-ui';
import { createAction, updateAction } from '../api';
import { getUsersList } from '../../User/api';
import moment from 'jalali-moment';
import Form from '../../../common/ui/components/MainForm/MainForm';
import '../styles.scss';

const validationSchema = yup.object({
    title: yup.string().required(),
    description: yup.string().required(),
    participants: yup.array().required().min(1, 'حداقل یک نفر باید حضور داشته باشد'),
    assignee: yup.string().required(),
    dueDate: yup.string().required(),
});

const ActionForm = props => {
    const { meetingId, handleCancel, handleAddAction, handleUpdateAction, actionToEdit } = props;
    const [participants, setParticipants] = useState([]);
    const [shouldEditData, setShouldEditData] = useState(false);
    const inputValues = actionToEdit
        ? {
              _id: actionToEdit._id,
              title: actionToEdit.title,
              description: actionToEdit.description,
              participants: actionToEdit.participants.map(participant => {
                  return { label: participant.fullname, value: participant._id };
              }),
              assignee: actionToEdit.assignee,
              dueDate: actionToEdit.dueDate,
          }
        : {
              title: '',
              description: '',
              participants: [],
              dueDate: '',
              assignee: '',
          };

    useEffect(() => {
        actionToEdit ? setShouldEditData(true) : setShouldEditData(false);
        const fetchParticipants = async () => {
            setParticipants(await getUsersList());
        };

        fetchParticipants();
    }, []);

    const { handleSubmit, values, handleChange, touched, errors, setFieldValue } = useFormik({
        initialValues: inputValues,
        onSubmit: values => {
            values.participants = values.participants.map(participant => participant.value);
            !shouldEditData
                ? createAction(meetingId, values).then(res => {
                      handleAddAction(res);
                  })
                : updateAction(meetingId, values).then(res => {
                      handleUpdateAction(res);
                  });
        },
        validationSchema,
    });

    const handleError = state => {
        if (touched[state] && errors[state]) return errors[state];
    };

    return (
        <div>
            <div>
                <Form
                    formTitle={actionToEdit ? `ویرایش اقدام ${actionToEdit.title}` : `افزودن اقدام جدید`}
                    handleCancel={handleCancel}
                    handleSubmit={handleSubmit}
                >
                    <TextField
                        classes={{ root: 'form-input' }}
                        value={values.title}
                        label={'عنوان'}
                        name="title"
                        placeholder="وارد کنید..."
                        onChange={handleChange('title')}
                        errorMessage={handleError('title')}
                    />
                    <TextField
                        classes={{ root: 'form-input' }}
                        value={values.description}
                        label={'توضیحات'}
                        name="description"
                        placeholder="وارد کنید..."
                        onChange={handleChange('description')}
                        errorMessage={handleError('description')}
                        multiline
                    />
                    <AutoComplete
                        selected={values.participants}
                        classes={{ input: 'form-input' }}
                        label="اعضای مربوطه"
                        multiple
                        onChange={(e, newValue) => {
                            setFieldValue('participants', newValue);
                        }}
                        options={participants.map(user => {
                            return { value: user._id, label: user.fullname };
                        })}
                        placeholder="انتخاب کنید..."
                        errorMessage={handleError('participants')}
                    />
                    <Select
                        classes={{ root: 'form-input' }}
                        name="assignee"
                        label="انجام دهنده کار"
                        options={values.participants}
                        onChange={handleChange('assignee')}
                        selected={actionToEdit?.assignee}
                    />
                    <DateTimePicker
                        classes={{ root: 'form-input datepicker' }}
                        value={values.dueDate}
                        label="مهلت انجام"
                        name="dueDate"
                        placeholder="وارد کنید..."
                        onChange={e => {
                            setFieldValue('dueDate', moment(e).format('jYYYY/jMM/jDD HH:mm'));
                        }}
                        errorMessage={handleError('dueDate')}
                        defaultValue={values.dueDate !== '' && moment.from(values.dueDate, 'fa', 'YYYY-MM-DDTHH:mm:ss')}
                    />
                </Form>
            </div>
        </div>
    );
};

export default ActionForm;
